import { escapeHtml } from '../shared/escape-html';

/** Egnyte's snippet is the file's plain text, so it shows as typed (X34). */
export function egnyteSnippetHtml(snippet: string | null | undefined): string {
  return escapeHtml(snippet);
}

/**
 * Microsoft Graph's hit summary marks matches with <c0>…</c0> and gaps with <ddd/>, and doesn't document whether the
 * text between them is encoded. The tags become <mark> and an ellipsis; the page binds the result through Angular's
 * sanitizer (no trust), which keeps it safe either way (X34).
 */
export function graphSummaryHtml(summary: string | null | undefined): string {
  return (summary ?? '')
    .replace(/<c0>/gi, '<mark>')
    .replace(/<\/c0>/gi, '</mark>')
    .replace(/<ddd\s*\/?>/gi, '…');
}
